export class Attachment {
  id: string;
  tipo: number;
  titulo: string;
  descricao: string;
  arquivo: string;
  arquivoURL: string;
  tipoCSS: string;
}
